import styled from 'styled-components'
import PropTypes from 'prop-types'

const TextButton = styled.div`
  color: #0070e0;
  font-size: ${props => (props.fontSize ? props.fontSize : '16px')};
  font-weight: 500;
  line-height: ${props => (props.fontSize ? props.fontSize : '19px')};
  cursor: pointer;
  margin: 0 auto;
  display: inline-block;
  outline: none;
  transition: all 0.4s;

  &:hover {
    color: #000000;
  }
`

TextButton.propTypes = {
  fontSize: PropTypes.string
}

export default TextButton



// WEBPACK FOOTER //
// ./src/components/typography/buttons/TextButton.js